import { Box, Divider, Hidden, makeStyles, styled, Typography, useMediaQuery, useTheme } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import algoliasearch from "algoliasearch";
import LocalOfferDesktopModal from "components/design-system/organisms/LocalOfferDesktopModal";
import LocalOfferMobileModal from "components/design-system/organisms/LocalOfferMobileModal";
import LocalOfferToggle from "components/design-system/organisms/LocalOfferToggle";
import FilterButton from "components/filters/mobileFilters/FiltersMobileButton";
import Footer from "components/footer";
import Header from "components/header";
import LocalOfferBlock from "components/localOffer/LocalOfferBlock";
import LocalSellingDrawer from "components/product/LocalSelling/LocalSellingDrawer";
import { MODELS_PER_PAGE } from "components/product/constants";
import SeoBloc from "components/seo/categoryText";
import { scrollToRef } from "components/utils";
import {
  getCategoryStaticDataTitle,
  getProductStaticDataDescription,
  getSubCategoryStaticTitle,
} from "data/categories";
import { capitalize, formatBreadcrumb, formatUrlFromMenu } from "helpers/algoliaUtils";
import useFilters from "hooks/useFilters";
import { pushCatalogClick } from "lib/gtm";
import { getCategories } from "lib/product";
import { useRouter } from "next/router";
import React, { useEffect, useRef, useState } from "react";
import {
  connectBreadcrumb,
  connectCurrentRefinements,
  connectHierarchicalMenu,
  connectHits,
  connectPagination,
  connectRange,
  connectRefinementList,
  connectSortBy,
  connectStateResults,
  DynamicWidgets,
  InstantSearch,
  SearchBox,
} from "react-instantsearch-dom";
import { TrimText } from "ui/TrimText/TrimText";
import DropdownList from "../../components/design-system/organisms/DropdownList/DropdownList";
import Reinsurance from "../../components/homepage/reinsurance";
import ConnectedAdressForm from "../../components/localOffer/ConnectedAddressForm";
import {
  getClientLocalCatalogs,
  resetEligibility,
  getClientCatalogs,
  setDefaultCatalog,
} from "../../components/localOfferEligibility/LocalOfferEligibility";
import Paginator from "../../components/paginator";
import ModelList from "../../components/product/ModelList";
import SeoCatalog from "../../components/seo/catalog";
import Breadcrumb from "./components/BreadCrumb";
import CheckBoxFilter from "./components/CheckBoxFilter";
import ClearFiltersBox from "./components/ClearFiltersBox";
import DesktopMenu from "./components/DesktopMenu";
import HitsNumber from "./components/HitsNumber";
import MobileMenu from "./components/MobileMenu";
import RangeInput from "./components/RangeInput";
import { transformObject } from "../../components/utils";

const reinsuranceItems = [
  {
    picto: "/reconditionne/homepage/reinsurance/planet_header.svg",
    label: "Reconditionné ou neuf",
  },
  {
    picto: "/reconditionne/homepage/reinsurance/warranty_header.svg",
    label: "Garanti 2 ans",
  },
  {
    picto: "/reconditionne/homepage/reinsurance/alma_header_yellow.svg",
    label: "Paiement en 3 fois",
  },
  {
    picto: "/reconditionne/homepage/reinsurance/local_shipping_header.svg",
    label: "Livraison rapide",
  },
];

const MobileStickyFilterBox = styled(Box)({ background: "white", position: "sticky", top: 0, zIndex: 2 });

const DesktopStickyCategoryBox = styled(Box)({
  top: 73,
  zIndex: 39,
  position: "sticky",
  backgroundColor: "white",
  borderBottom: "1px solid rgba(219, 223, 232, 0.6);",
});

const FlexCategoryBox = styled(Box)({
  height: 73,
});

const FilterComponent = () => {
  return (
    <DynamicWidgets>
      <CustomRefinementList title="Marque" attribute="brand" searchable facetOrdering limit={100} />
      <CustomRefinementList title="Type d'ouverture" attribute="opening_type" />
      <CustomRefinementList title="Type de pose" attribute="installation_type" />
      <CustomRefinementList title="Apparence de l'appareil" attribute="appearance" />
      <CustomRefinementList title="Type de cuisson" attribute="cooking_method" />
      <CustomRefinementList title="Type de froid" attribute="cooling_method" />
      <CustomRefinementList title="Classe Énergétique" attribute="energy_class" />
      <CustomRefinementList title="Type de séchage" attribute="dryer_type" />
      <CustomRangeInput title="Puissance (en W)" attribute="power" />
      <CustomRangeInput
        title="Capacité (en L)"
        attribute="functional_characteristics.Capacité (en L) partie réfrigérateur"
        unit="L"
      />
      <CustomRangeInput title="Capacité (en kg)" attribute="functional_characteristics.Capacité (en kg)" unit="kg" />
      <CustomRangeInput
        title="Capacité séchage (en kg)"
        attribute="functional_characteristics.Capacité séchage (en kg)"
        unit="kg"
      />
      <CustomRangeInput
        title="Capacité lavage (en kg)"
        attribute="functional_characteristics.Capacité lavage (en kg)"
        unit="kg"
      />
      <CustomRangeInput
        title="Niveau sonore (en db)"
        attribute="functional_characteristics.Niveau sonore (en db)"
        unit="db"
      />
      <CustomRangeInput title="Profondeur" attribute="depth" unit="cm" />
      <CustomRangeInput title="Hauteur" attribute="height" unit="cm" />
      <CustomRangeInput title="Largeur" attribute="width" unit="cm" />
      <CustomRangeInput title="Volume total" attribute="total_fridge_volume" unit="L" />
      <CustomRangeInput title="Prix" attribute="price" unit="€" />
      <CustomRangeInput
        title="Nombre de couverts"
        attribute="functional_characteristics.Capacité (en nombre de couverts)"
        unit="couverts"
      />
      <CustomRangeInput
        title="Capacité (en nombre de feux)"
        attribute="functional_characteristics.Capacité (en nombre de feux)"
        unit="feux"
      />
      <CustomRefinementList title="Catalog" attribute="catalogs.slug" hidden />
    </DynamicWidgets>
  );
};
const searchClient = algoliasearch("BKMIHZP70W", "61762fac5af6076506af777bba5e421c");

export default function Catalog({ category, category1, catalogName, categories }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [state, dispatch] = useFilters();
  const searchState = state?.searchState || {};
  const setSearchState = (state) => {
    dispatch({ type: "updateSearchState", searchState: state });
  };
  const [numberOfFilters, setNumberOfFilters] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const debouncedSetStateRef = useRef(null);
  const router = useRouter();
  const breadCrumbRef = useRef();
  const classes = useStyle();

  useEffect(() => {
    setSearchState({
      refinementList:
        urlToSearchState().refinementList && urlToSearchState().refinementList["appearance"]
          ? {
              appearance: urlToSearchState().refinementList["appearance"],
            }
          : urlToSearchState().refinementList,
      query: urlToSearchState().query,
      range: urlToSearchState().range,
      hierarchicalMenu: urlToSearchState().hierarchicalMenu,
      page: urlToSearchState().page,
    });
    if (router.query?.catalog) {
      setDefaultCatalog(router.query.catalog);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.query]);

  function onSearchStateChange(updatedSearchState) {
    setIsLoading(true);
    clearTimeout(debouncedSetStateRef.current);
    debouncedSetStateRef.current = setTimeout(() => {
      if (urlToSearchState().hierarchicalMenu?.category !== updatedSearchState.hierarchicalMenu?.category) {
        router.push(searchStateToUrl(updatedSearchState));
      }
    }, 400);
    setSearchState(updatedSearchState);
  }

  const createURL = (state) => {
    let queryString = "";
    let pathname = router.pathname;
    let url = formatUrlFromMenu(state.hierarchicalMenu?.category, "", categories);
    pathname = pathname.substring(0, pathname.lastIndexOf("reconditionne")) + "reconditionne";
    if (router.asPath.includes("?")) {
      queryString += "?";
      queryString += router.asPath.split("?")[1];
    }
    return pathname + url + queryString;
  };

  const searchStateToUrl = (searchState) => (searchState ? createURL(searchState) : "");
  // resets filters while leaving the menu values untouched
  const resetFilters = () => {
    dispatch({ type: "resetFilters", searchState: {} });
  };

  const urlToSearchState = () => {
    const query = router?.query;
    let queryObject = {
      page: query?.page || 1,
      refinementList: { "catalogs.slug": getClientCatalogs(true, query?.catalog) },
      query: decodeURIComponent(query?.search || ""),
      hierarchicalMenu: category ? { category: formatBreadcrumb(category, category1) } : {},
    };

    if (query) {
      if (query.available_appearances || query.appearance)
        query["refinementList__appearance"] = query.appearance || query.available_appearances;
      queryObject = {
        ...queryObject,
        range: { ...transformObject(query)?.range },
        refinementList: { ...queryObject.refinementList, ...transformObject(query)?.refinementList },
      };
    }

    return queryObject;
  };

  const addCatalogsToRefinementList = () => {
    const newSearchState = {
      ...searchState,
      page: 1,
      refinementList: {
        ...searchState.refinementList,
        "catalogs.slug": getClientCatalogs(true),
      },
    };
    setSearchState(newSearchState);
  };

  const addCatalogsAndScrollToTop = () => {
    addCatalogsToRefinementList();
    scrollToTop();
  };

  const removeCatalogsFromRefinementList = () => {
    setSearchState({
      ...searchState,
      page: 1,
      refinementList: { "catalogs.slug": getClientCatalogs(false) },
    });
  };

  const scrollToTop = () => scrollToRef(breadCrumbRef);

  const isClientEligible = getClientLocalCatalogs()?.length > 0;

  const toggleMobileLocalOfferModal = () => {
    if (isClientEligible) {
      resetEligibility();
      removeCatalogsFromRefinementList();
    }
  };

  return (
    <>
      <Header categories={categories} />
      <Reinsurance content={reinsuranceItems} darkMode />
      <SeoCatalog models={[]} />
      <InstantSearch
        createURL={createURL}
        searchState={searchState}
        searchClient={searchClient}
        indexName={catalogName}
        onSearchStateChange={onSearchStateChange}
      >
        <SearchBox className={classes.searchInput} />
        <LoadingStatus setIsLoading={setIsLoading} />
        <Hidden mdDown>
          <Box mt={7} px={7}>
            <LocalOfferBlockWithFilterData
              addCatalogsToRefinementList={addCatalogsToRefinementList}
              removeCatalogsFromRefinementList={removeCatalogsFromRefinementList}
            />
          </Box>
        </Hidden>
        <Box px={isMobile ? 0 : 7}>
          <Box ml={isMobile ? 2 : 0} ref={breadCrumbRef}>
            <CustomBreadcrumb attributes={["category", "category1_breadcrumb"]} />
          </Box>

          <Box>
            <Box justifyContent={"space-between"} display={"flex"} alignItems={"center"} px={isMobile ? 2 : 0} pt={2}>
              <Box>
                <Box className={category === undefined ? classes.titleContainer : ""}>
                  <Typography
                    variant="h1"
                    className={classes.title}
                    style={{ fontSize: isMobile ? 22 : 24, color: isMobile ? "#005646" : "#1B1E1C" }}
                  >
                    <Box display="flex">
                      {searchState.query
                        ? `Tous les produits correspondants à ${decodeURIComponent(searchState.query)}`
                        : category1
                        ? getSubCategoryStaticTitle(category1)
                        : category
                        ? getCategoryStaticDataTitle(router.query.category)
                        : "Nos électroménagers reconditionnés et durables"}
                      <Hidden mdDown>
                        <Box alignSelf="end" ml={1}>
                          <CustomHitsNumber />
                        </Box>
                      </Hidden>
                    </Box>
                  </Typography>
                </Box>
                {category && !isMobile && (
                  <Typography className={classes.description}>
                    <TrimText text={getProductStaticDataDescription(router.query.category)} trimLength={60} />
                  </Typography>
                )}
              </Box>
            </Box>
          </Box>
          <Hidden mdDown>
            <DesktopStickyCategoryBox>
              <FlexCategoryBox display={"flex"} justifyContent={"end"}>
                {!isMobile && (
                  <CustomDesktopMenu catalogName={catalogName} attributes={["category", "category1_breadcrumb"]} />
                )}
                <Box mr={{ lg: 0, xl: 2 }} ml={{ lg: 2, xl: 6 }} my={"auto"}>
                  <LocalOfferDesktopModal
                    addCatalogsToRefinementList={addCatalogsAndScrollToTop}
                    removeCatalogsFromRefinementList={removeCatalogsFromRefinementList}
                  ></LocalOfferDesktopModal>
                </Box>
                <Box pt={1}>
                  <CustomSortBy
                    defaultRefinement={catalogName}
                    items={[
                      { value: catalogName, label: "Trier" },
                      { value: `${catalogName}_discount_desc`, label: "Économies (%)" },
                      { value: `${catalogName}_price_asc`, label: "Prix: Croissant" },
                      { value: `${catalogName}_price_desc`, label: "Prix: Décroissant" },
                    ]}
                    scrollToTop={scrollToTop}
                  />
                </Box>
              </FlexCategoryBox>
            </DesktopStickyCategoryBox>
          </Hidden>
          <Box>
            {category && isMobile && (
              <Typography className={classes.description}>
                {getProductStaticDataDescription(router.query.category)}
              </Typography>
            )}
          </Box>
          <Hidden lgUp>
            <Box width={"100vw"} className={classes.scrollContainer}>
              <Box overflow={"auto"}>
                {isMobile && <CustomMobileMenu attributes={["category", "category1_breadcrumb"]} />}
              </Box>
            </Box>
            <MobileStickyFilterBox>
              <Box display={"flex"} width="100%" justifyContent="space-between" alignItems={"center"} py={2}>
                <FilterButton
                  filterComponent={<FilterComponent />}
                  onReset={resetFilters}
                  numberOfFiltersOverride={numberOfFilters}
                />
                <LocalOfferMobileModal
                  preventOpening={isClientEligible}
                  autoFocusField={false}
                  addCatalogsToRefinementList={addCatalogsAndScrollToTop}
                >
                  <LocalOfferToggle isActivated={isClientEligible} handleChange={toggleMobileLocalOfferModal} />
                </LocalOfferMobileModal>
                <CustomStateResults setNumberOfFilters={setNumberOfFilters} />
              </Box>
              <Divider />
            </MobileStickyFilterBox>
            <Box width="100%" textAlign="center" py={2}>
              {isClientEligible && (
                <Box px={2}>
                  <LocalOfferMobileModal autoFocusField={false} addCatalogsToRefinementList={addCatalogsAndScrollToTop}>
                    <ConnectedAdressForm
                      id="disabled"
                      autoFocusField={false}
                      addCatalogsToRefinementList={() => undefined}
                      disabled
                    />
                  </LocalOfferMobileModal>
                </Box>
              )}
              <CustomHitsNumber />
            </Box>
          </Hidden>
          <Box display="flex" mt={3}>
            <Hidden mdDown>
              <Box minWidth={280}>
                <Box pr={2} width={"max-content"}>
                  <Box mb={5} id="local-offer-left">
                    <LocalSellingDrawer addCatalogsToRefinementList={addCatalogsAndScrollToTop} />
                  </Box>

                  <FilterComponent />
                </Box>
              </Box>
            </Hidden>
            <Box width={"100%"}>
              <Hidden mdDown>
                <CustomClearFilterBox
                  transformItems={(items) => items.filter((item) => item.attribute !== "category")}
                />
              </Hidden>
              <Box>
                {isLoading ? (
                  <HitsSkeleton classes={classes} />
                ) : (
                  <CustomHits
                    router={router}
                    classes={classes}
                    searchState={searchState}
                    addCatalogsToRefinementList={addCatalogsAndScrollToTop}
                    removeCatalogsFromRefinementList={removeCatalogsFromRefinementList}
                  />
                )}
              </Box>
              <CustomPagination scrollToTop={scrollToTop} />
            </Box>
          </Box>
        </Box>
      </InstantSearch>
      {category && !category1 && (
        <SeoBloc category={categories.find((cat) => cat.name === capitalize(category))?.slug} displayFullText={false} />
      )}
      <Footer />
    </>
  );
}

const HitsSkeleton = ({ classes }) => {
  return [...Array(3).keys()].map((item) => (
    <div key={item}>
      <Box className={classes.grid}>
        <Skeleton variant="rectangular" height={415} />
        <Skeleton variant="rectangular" height={415} />
        <Skeleton variant="rectangular" height={415} />
      </Box>
      <Box className={classes.grid}>
        <Typography variant="h1">
          <Skeleton />
        </Typography>
        <Typography variant="h1">
          <Skeleton />
        </Typography>
        <Typography variant="h1">
          <Skeleton />
        </Typography>
      </Box>
    </div>
  ));
};

const Hits = ({
  hits,
  router,
  classes,
  searchState,
  addCatalogsToRefinementList,
  removeCatalogsFromRefinementList,
}) => {
  return (
    <ModelList
      classesOverride={classes}
      selectedAppearances={(searchState?.refinementList && searchState?.refinementList["appearance"]) || []}
      models={hits.map((hit) => ({ ...hit, width: null }))}
      addCatalogsToRefinementList={addCatalogsToRefinementList}
      removeCatalogsFromRefinementList={removeCatalogsFromRefinementList}
      onProductClick={(model, category, position) => {
        const category_slug = router?.query?.category ? { slug: router.query.category } : { slug: "catalogue" };
        pushCatalogClick(model, category_slug, position);
      }}
    />
  );
};

const Pagination = ({ currentRefinement, nbPages, refine, scrollToTop }) => {
  return (
    <Paginator
      pagination={{
        currentPage: currentRefinement,
        itemsPerPage: MODELS_PER_PAGE,
        totalItems: nbPages * MODELS_PER_PAGE,
      }}
      onPageChange={(page) => {
        refine(page);
        scrollToTop();
      }}
    />
  );
};

const FilterNumber = ({ searchState, setNumberOfFilters }) => {
  let number = 0;
  if (searchState.refinementList) {
    Object.keys(searchState.refinementList)
      .filter((k) => !k.includes("catalog"))
      .forEach((refinement) => {
        number += searchState.refinementList[refinement] ? 1 : 0;
      });
  }
  if (searchState.range) {
    number += Object.keys(searchState.range).length;
  }
  setNumberOfFilters(number);
  return null;
};

const isLoading = ({ searchState, searchResults, setIsLoading, isSearchStalled }) => {
  const isLoading =
    isSearchStalled ||
    searchResults?.nbHits === undefined ||
    !(searchState?.refinementList && searchState?.refinementList["catalogs.slug"]);
  if (!isLoading) {
    setTimeout(() => setIsLoading(false), 500);
  } else {
    setIsLoading(isLoading);
  }
  return null;
};

const CustomClearFilterBox = connectCurrentRefinements(ClearFiltersBox);
const LoadingStatus = connectStateResults(isLoading);
const CustomStateResults = connectStateResults(FilterNumber);
const LocalOfferBlockWithFilterData = connectStateResults(LocalOfferBlock);
const CustomBreadcrumb = connectBreadcrumb(Breadcrumb);
const CustomSortBy = connectSortBy(DropdownList);
const CustomHits = connectHits(Hits);
const CustomPagination = connectPagination(Pagination);
const CustomDesktopMenu = connectHierarchicalMenu(DesktopMenu);
const CustomMobileMenu = connectHierarchicalMenu(MobileMenu);
const CustomRangeInput = connectRange(RangeInput);
const CustomRefinementList = connectRefinementList(CheckBoxFilter);
const CustomHitsNumber = connectStateResults(HitsNumber);

export async function getStaticProps() {
  const categories = await getCategories();
  const formattedCategories = categories.map((category) => ({
    ...category,
    ...{ subcategories1: null, subcategories2: null },
  }));
  const catalogName = process.env.ALGOLIA_CATALOG_NAME;
  return {
    props: {
      categories: formattedCategories,
      catalogName: catalogName,
    },
    revalidate: 30,
  };
}

const useStyle = makeStyles((theme) => ({
  scrollContainer: {
    "& ::-webkit-scrollbar": {
      display: "none",
    },
  },
  searchInput: {
    display: "none",
  },
  sticked: {
    zIndex: 5,
    backfaceVisibility: "hidden",
    padding: 13,
    bottom: 24,
    position: "fixed",
    width: "100%",
    textAlign: "center",
  },
  titleContainer: {
    marginBottom: theme.spacing(2),
  },
  title: {
    fontWeight: 500,
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)",
    gridColumnGap: theme.spacing(3),
    overflow: "hidden",
    width: "100%",
    gridRowGap: theme.spacing(5),
    marginBottom: theme.spacing(3),
    [theme.breakpoints.up("md")]: {
      paddingLeft: 56,
      marginBottom: theme.spacing(5),
      maxWidth: "100%",
      gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)  minmax(0, 1fr)",
      gridColumnGap: theme.spacing(3),
      marginRight: "auto",
      overflow: "unset",
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  description: {
    marginTop: theme.spacing(),
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(5),
    fontSize: 14,
    [theme.breakpoints.down("sm")]: {
      fontSize: 12,
      color: theme.palette.text.disabled,
      marginLeft: theme.spacing(2),
    },
  },
}));
